<template>
    <v-card outlined>
        <v-card-title>
            {{ title }}
            <v-spacer></v-spacer>
            <v-chip :color="chipColor" small>{{ items.length }}</v-chip>
        </v-card-title>

        <v-data-table :headers="headers" :items="items" :loading="loading" loading-text="Carregando..."
            :hide-default-footer="true" :items-per-page="10" dense>
            <template v-slot:body="{ items }">
                <tbody>
                    <tr v-for="item in items" :key="item.GERCON">
                        <td>{{ item.company || '' }}</td>
                        <td>{{ item.unit || '' }}</td>
                        <td>{{ item.DESAREA || '' }}</td>
                        <td>{{ item.DESARE || '' }}</td>
                        <td>{{ item.NOMUSU }}</td>
                        <td>{{ item.TITCON }}</td>
                        <td>{{ item.DATA_CADASTRO ? formatDate(item.DATA_CADASTRO) : '' }}</td>
                        <td>{{ contractTypeEnum[item.TIPCON] }}</td>
                        <td>
                            <v-chip :color="getSituacaoColor(item.SITUACAO)" small text-color="white">
                                {{ getSituacao(item.SITUACAO) }}
                            </v-chip>
                        </td>
                        <td>
                            <v-btn color="primary" small
                                @click="$emit('open-contract', item.GERCON, user.CODUSU !== item.USUCAD)">
                                {{ buttonLabel }}
                            </v-btn>

                        </td>
                    </tr>
                    <tr v-if="items.length === 0">
                        <td colspan="100%" class="text-center">Nenhum contrato encontrado.</td>
                    </tr>
                </tbody>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import { ContractTypeEnum } from './enums/ContractTypeEnum';
import { formatDate } from "@/plugins/utils";

export default {
    name: "ContractFlowTable",
    props: {
        title: String,
        items: Array,
        loading: Boolean,
        chipColor: {
            type: String,
            default: "primary"
        },
        user: Object,
        buttonLabel: {
            type: String,
        }
    },
    data() {
        return {
            contractTypeEnum: ContractTypeEnum,
            headers: [
                { text: "Empresa", align: "left", value: "company.DESABR", width: "12%" },
                { text: "Unidade", align: "left", value: "unit.DESUNI", width: "12%" },
                { text: "Área Corporativa", align: "left", value: "area.DESARE", width: "12%" },
                { text: "Setor", align: "left", value: "corporateArea.DESAREA", width: "12%" },
                { text: "Solicitante", align: "left", value: "USUCAD", width: "12%" },
                { text: "Contrato", align: "left", value: "TITCON", width: "20%" },
                { text: "Data de cadastro", align: "center", value: "DATCAD", width: "12%" },
                { text: "Tipo", align: "center", value: "TIPCON", width: "10%" },
                { text: "Situação", align: "center", value: "SITUACAO", width: "10%" },
                { text: "Ação", align: "center", sortable: false, value: "actions", width: "10%" },
            ],
        };
    },
    methods: {
        formatDate,
        getSituacao(sit) {
            switch (sit) {
                case 1: return "Cadastrado";
                case 2: return "Em Avaliação";
                case 3: return "Aguardando Assinatura";
                case 4: return "Retornado";
                case 5: return "Versão Final Assinado";
                case 6: return "Concluído";
                default: return "Desconhecido";
            }
        },
        getSituacaoColor(sit) {
            switch (sit) {
                case 1: return "blue";
                case 2: return "orange";
                case 3: return "purple";
                case 4: return "red";
                case 5: return "green";
                case 6: return "grey";
                default: return "grey";
            }
        },
    },
};
</script>
